module.exports = __webpack_public_path__ + "static/img/IMG_3551.62afc12.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/IMG_3551.jpg
// module id = CDVR
// module chunks = 9